<form *ngIf="productCode" [formGroup]="addToCartForm" (submit)="addToCart()">
  <div class="quantity mb-3" *ngIf="showQuantity">
    <div class="cx-counter-stock">
      <cx-item-counter
        *ngIf="hasStock"
        [max]="maxQuantity"
        [control]="$any(addToCartForm.get('quantity'))"
      ></cx-item-counter>

      <span style="font-size: 13px" class="my-1">
        <span *ngIf="showInventory$ | async">{{ getInventory() }}</span>
        {{ hasStock ? ('addToCart.inStock' | cxTranslate) : ('addToCart.outOfStock' | cxTranslate) }}</span
      >
    </div>
  </div>

  <ng-container *ngIf="hasStock">
    <ng-template
      [cxOutlet]="CartOutlets.ADD_TO_CART_PICKUP_OPTION"
      [(cxComponentRef)]="pickupOptionCompRef"
    ></ng-template>
  </ng-container>

  <button
    *ngIf="hasStock"
    [ngClass]="options?.displayAddToCart ? 'btn btn-tertiary' : 'btn btn-primary btn-block'"
    type="submit"
    [disabled]="quantity <= 0 || quantity > maxQuantity"
    class="mt-5"
  >
    <span *ngIf="options?.addToCartString === ('addToCart.buyItAgain' | cxTranslate)" class="repeat-icon"
      ><cx-icon [type]="iconTypes.REPEAT"></cx-icon
    ></span>
    <span
      attr.aria-label="{{ options?.addToCartString ?? ('addToCart.addToCart' | cxTranslate) }}"
      [ngClass]="options?.addToCartString === ('addToCart.buyItAgain' | cxTranslate) ? 'buyItAgainLink' : ''"
      style="text-transform: initial"
    >
      <i class="bi bi-cart3" style="color: white !important; margin-right: 5px"></i>
      Añadir al carrito
    </span>
  </button>

  <ng-container *ngIf="((hasFutureStock$ | async) == true) && ((hasNoStock$ | async) == true)">
    <div class="d-none">
      <h4 *ngIf="(futureStock$ | async) as fstock" class="mt-5">
        Información:
        <br />
        {{ fstock.stock.stockLevel | i18nPlural: { 
          '=0': 'No existen unidades en tránsito',
          '=1': 'Existe 1 unidad en tránsito, estará disponible a partir del día ' + fstock.formattedDate,
          'other': 'Existen ' + fstock.stock.stockLevel + ' unidades en tránsito, estarán disponibles a partir del día ' + fstock.formattedDate
        } }}
    </h4>
  </div>
  </ng-container>
</form>
